// operational panel will check which element needs binding key, and show a alert icon if it needs but not given.

export const elementsNeedBindingKey = [
  "textField",
  "checkbox",
  "select",
  "textarea",
  "imageUploader",
  "radioGroup",
  "datePicker",
  "multiSelect",
  "timeIntervalSelect",
  "chipGroup",
];

export default [
  "textField",
  "checkbox",
  "select",
  "textarea",
  "imageUploader",
  "radioGroup",
  "datePicker",
  "multiSelect",
  "timeIntervalSelect",
  "chipGroup",
];
